export const ONBOARDING_LINKS = {
    CHILDREN: 'https://new.brandnewday.nl/kinderrekening-of-beleggingsrekening',
};

// export const getOnboardingLink = (parameters: GoalIndicationParameters) => {
//     if (parameters.selectedGoal === 'children') {
//         return ONBOARDING_LINKS.CHILDREN;
//     }
//     return 'https://secure.brandnewday.nl/rekening-openen/beleggingsrekening';
// };

export const modelPortfolioUrls = {
    modelInvestment: 'https://new.brandnewday.nl/particulier/bank-modelbeleggen/',
    firstUmbrellaFund: 'https://www.brandnewday.nl/content/app/pdf/documentencentrum/Prospectus/Prospectus-BND-PFI.pdf',
    secondUmbrellaFund:
        'https://www.brandnewday.nl/content/app/pdf/documentencentrum/Prospectus/Prospectus-BND-PFII.pdf',
};

export const DOCUMENT_CENTRUM_URL = 'https://new.brandnewday.nl/documentencentrum/';
export const FAQ_INVESTMENT_ADVICE_URL = 'https://new.brandnewday.nl/veelgestelde-vragen/beleggen/kunnen-jullie-mij-beleggingsadvies-geven/';
export const CALL_EXPERT_URL = 'https://new.brandnewday.nl/belafspraak/';
export const AFM_URL = 'https://www.afm.nl/ebi';
export const PRIVACY_URL = 'https://new.brandnewday.nl/wp-content/uploads/2019/05/Def_privacy_statement_algemeen_2019.pdf';
export const MIJNPENSIOENOVERZICHT_URL = 'https://www.mijnpensioenoverzicht.nl/';

const pessimisticBlue = '#2147CF';
const medianBlue = '#3661FE';
const optimisticBlue = '#6486FF';
const bndBlue = '#2147CF';
const bndPink = '#CE6891';
const bndPinkLight = 'hsla(336, 51%, 61%, 20%)';
const bndGreen = '#00B263';
const bndGreenDark = '#50AF6A';
const bndBlack = '#333333';
const bndGrey = '#646464';
const bndWhite = '#FEFEFE';
const bndFondsOrange = '#EABB40';
const bndInvestmentLine = '#CE6891';
const bndBarChartBlue = '#2A4CA9';

const shares = ['#D09803', '#E9B93C', '#FFDA75', '#FFE8AC'];
const obligates = ['#2F4FA3', '#3875AA', '#72CBD8', '#A3F3FF'];

const listColors = [
    '#2F4FA3',
    '#3875AA',
    '#92BED4',
    '#72CBD8',
    '#D2E773',
    '#A2D87A',
    '#73CB81',
    '#FFEDBE',
    '#FFDD83',
    '#BF4A28',
];

const total = [...listColors, ...listColors, ...listColors];

export const COLORS = {
    pessimisticBlue,
    medianBlue,
    optimisticBlue,
    bndBlue,
    bndPink,
    bndPinkLight,
    bndGreen,
    bndGreenDark,
    bndBlack,
    bndGrey,
    bndWhite,
    shares,
    obligates,
    total,
    bndFondsOrange,
    bndInvestmentLine,
    bndBarChartBlue,
};

export type Breakpoint = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

export const breakpoints: { minWidth: number; tag: Breakpoint }[] = [
    { minWidth: 640, tag: 'sm' },
    { minWidth: 768, tag: 'md' },
    { minWidth: 1024, tag: 'lg' },
    { minWidth: 1280, tag: 'xl' },
    { minWidth: 1536, tag: '2xl' },
];

export const SELECTED_FUND_COLORS = [COLORS.bndFondsOrange, COLORS.bndBlue, COLORS.bndPink];
export const LINE_CHART_COLORS: { chart: string; legend: string }[] = [
    // COLORS.optimisticBlue,
    // COLORS.medianBlue,
    // COLORS.pessimisticBlue
    {
        chart: 'rgba(145,194,225,0.3)',
        legend: '#D9E7F2',
    },
    {
        chart: 'rgba(42,76,169,0.8)',
        legend: '#536EB8',
    },
    {
        chart: 'rgba(145,194,229,0.8)',
        legend: '#91C2E5',
    },
];

export const DISABLED_OPTION_PLACHOLDER_ID = "DISABLED_OPTION_PLACHOLDER_ID"

export type ROBOT_ENVIRONMENT = 'MyBND' | 'Marketing' | 'Advisor' | 'External' | 'Rich Media';
export type CLIENT_DETAILS_OPTIONS = 'first' | 'last' | 'default';

export const riskProfiles = {
    'veryDefensive': '8',
    'defensive': '9',
    'neutral': '10',
    'offensive': '11',
    'veryOffensive': '12',
}
